import * as React from 'react';

import { Modal, Stack } from 'react-bootstrap';

import CheckmateSelect from '../../shared/CheckmateSelect';
import { IMultiSelectOption } from '../../../interfaces/ILookup';
import { IValidation } from '../../../interfaces/IError';

export interface ISameCaseDetailsSelectorModalProps {
    currentCaseGroupName?: string;
    currentCaseGroupNumber?: string;
    distinctNames: string[];
    distinctNumbers: string[];
    onCancelClick: () => void;
    onSubmitClick: (caseGroupName: string, caseGroupNumber: string) => void;
    validation?: IValidation;
}

export function SameCaseDetailsSelectorModal(props: ISameCaseDetailsSelectorModalProps) {
    const [caseGroupNumber, setCaseGroupNumber] = React.useState<string>(
        props.currentCaseGroupNumber ?? ''
    );
    const [caseGroupName, setCaseGroupName] = React.useState<string>(
        props.currentCaseGroupName ?? ''
    );
    
    const handleCaseGroupNameChange = (selectedOption: { value: string; label: string } | null) => {
        if (selectedOption) {
            setCaseGroupName(selectedOption.value);
        }
    };

    const handleCaseGroupNumberChange = (
        selectedOption: { value: string; label: string } | null
    ) => {
        if (selectedOption) {
            setCaseGroupNumber(selectedOption.value);
        }
    };

    const handleSubmitClick = () => {
        props.onSubmitClick(caseGroupName, caseGroupNumber);
    };

    const distinctCaseNameOptions = props.distinctNames.map(
        (name, idx) =>
            ({
                value: name,
                label: name,
                id: idx,
            } as IMultiSelectOption)
    );

    const distinctCaseNumberOptions = props.distinctNumbers.map(
        (number, idx) =>
            ({
                value: number,
                label: number,
                id: idx,
            } as IMultiSelectOption)
    );

    return (
        <Modal centered show={true} backdrop>
            <Modal.Header>
                <Modal.Title>Select Same Case Values</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div>
                    <span className="text-danger">{props.validation?.model}</span>
                </div>
                <p>
                    Select the Case Name and Case Number to use for this Same Case. If all cases
                    within the Same Case have the same values, those values will be pre-selected and unchangeable.
                </p>
                <Stack gap={3}>
                    <div>
                        <div>
                            Case Name
                        </div>
                        <CheckmateSelect
                            onChange={handleCaseGroupNameChange}
                            options={distinctCaseNameOptions}
                            value={distinctCaseNameOptions.find(
                                (opt) => opt.value === caseGroupName
                            )}
                            isDisabled={props.distinctNames.length <= 1}
                        />
                    </div>
                    <div>
                        <div>
                            Case Number
                        </div>
                        <CheckmateSelect
                            onChange={handleCaseGroupNumberChange}
                            options={distinctCaseNumberOptions}
                            value={distinctCaseNumberOptions.find(
                                (opt) => opt.value === caseGroupNumber
                            )}
                            isDisabled={props.distinctNumbers.length <= 1}
                        />
                    </div>
                </Stack>
            </Modal.Body>
            <Modal.Footer>
                <button className="btn btn-orange" onClick={handleSubmitClick}>
                    Save
                </button>
                <button className="btn btn-default" onClick={props.onCancelClick}>
                    Cancel
                </button>
            </Modal.Footer>
        </Modal>
    );
}
